import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import useAcademyCategories from '../useAcademyCategories';
import { useParams } from 'react-router-dom';
import FormHelper from 'helpers/FormHelper';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  let { id } = useParams();

  const { shoppingCenters, form, handleCreateOrUpdateShop } =
    useAcademyCategories(false, id);

  const onFinish = async (values) => {
    await handleCreateOrUpdateShop(values, id);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew
    ? t('CREARE ACADEMY CATEGORY')
    : t('MODIFICA ACADEMY CATEGORY COMMERCIALI');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
          initialValues={{
            title: '',
            shopping_center_id: '',
            macro_area: '',
            year: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <InfoSection shoppingCenters={shoppingCenters} />
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Edit;
